import { Flex, FormLabel } from "@chakra-ui/react";
import * as AF from "src/types/formTemplate";
import * as RD from "src/types/remoteData";
import { QuestionVisibilitySwitch } from "../../QuestionVisibility";
import { PermissionLevelSwitch } from "../Edit/PermissionLevel";
import { QuestionConstraintsSwitch } from "../Edit/QuestionContraints";
import { QuestionLinkSwitch } from "../Edit/QuestionLink";
import { RequirementSwitch } from "../Edit/Requirement";
import { VerificationSwitch } from "../Edit/Verification";
import { SchoolItem } from "../types";

type Props = {
  questionId: uuid;
  sectionType: AF.V3.SectionType;
  otherQuestions: readonly AF.V3.Question[];
  schools: RD.RemoteData<unknown, SchoolItem[]>;
  hide?: "QuestionVisibility"[];
};
export const ConfigureQuestion: React.FC<Props> = ({
  questionId,
  hide,
  sectionType,
  otherQuestions,
  schools,
}) => {
  return (
    <Flex direction="column" gap="3" flexGrow="1">
      <FormLabel as="div" margin="0">
        Configure question
      </FormLabel>
      <VerificationSwitch questionId={questionId} />
      <QuestionLinkSwitch questionId={questionId} />
      <PermissionLevelSwitch questionId={questionId} />
      <RequirementSwitch questionId={questionId} />
      <QuestionConstraintsSwitch questionId={questionId} />
      {!hide?.includes("QuestionVisibility") ? (
        <QuestionVisibilitySwitch
          questionId={questionId}
          sectionType={sectionType}
          otherQuestions={otherQuestions}
          schools={schools}
        />
      ) : null}
    </Flex>
  );
};
